/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventModel } from './EventModel';
import { EventModelFromJSON, EventModelFromJSONTyped, EventModelToJSON } from './EventModel';

/**
 *
 * @export
 * @interface ListEventsByDateResponse
 */
export interface ListEventsByDateResponse {
    /**
     *
     * @type {Array<EventModel>}
     * @memberof ListEventsByDateResponse
     */
    events: Array<EventModel>;
}

/**
 * Check if a given object implements the ListEventsByDateResponse interface.
 */
export function instanceOfListEventsByDateResponse(value: object): boolean {
    if (!('events' in value)) return false;
    return true;
}

export function ListEventsByDateResponseFromJSON(json: any): ListEventsByDateResponse {
    return ListEventsByDateResponseFromJSONTyped(json, false);
}

export function ListEventsByDateResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ListEventsByDateResponse {
    if (json == null) {
        return json;
    }
    return {
        events: (json['events'] as Array<any>).map(EventModelFromJSON),
    };
}

export function ListEventsByDateResponseToJSON(value?: ListEventsByDateResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        events: (value['events'] as Array<any>).map(EventModelToJSON),
    };
}
